import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import { useSnackbarContext } from 'Context/SnackbarContext';

const useStyles = makeStyles({
  root: {
    padding: 0,
    margin: 0,
  },
  lastForm: {
    margin: 0,
  },
  firstForm: {
    margin: 0,
  },
});

const MetaForm = ({
  className,
  collection,
  layout,
  metaOverrideSet,
  throwFailures,
  ...rest
}) => {
  const { displayErrorMessage } = useSnackbarContext();
  const classes = useStyles();
  return (
    <MetaCollectionFormInline
      className={classNames(className, classes.root)}
      classes={classes}
      metaOverrideSet={metaOverrideSet}
      collection={collection}
      FormProps={{
        layout,
        readonly: true,
        onFailure: (err) => {
          if (throwFailures) {
            throw err;
          }

          displayErrorMessage('Failed to save', err?.errors);
        },
      }}
      {...rest}
    />
  );
};

MetaForm.defaultProps = {
  className: '',
  metaOverrideSet: null,
  throwFailures: false,
};

MetaForm.propTypes = {
  className: PropTypes.string,
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
  layout: PropTypes.element.isRequired,
  throwFailures: PropTypes.bool,
  metaOverrideSet: PropTypes.instanceOf(fr.metaOverride),
};

export default MetaForm;
